//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignNameModal",
  components: {
    MaterialInput,
    GenericModal,
    SimpleButton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: ""
    };
  },
  computed: {
    createButtonDisabled() {
      return !this.name.length;
    }
  },
  methods: {
    showModal() {
      this.name = "";
      this.$showModal();
    },
    hideModal() {
      this.$hideModal();
    },
    handleCreate() {
      this.$emit("create", this.name);
    }
  }
});